module.exports = __webpack_public_path__ + "static/ad-4c5a7f3a0fa0c8653435b3a1be701314.jpg";